import React from 'react'
import { useCartItems, CartItemsProps } from './useCartItems'
import { Link } from 'react-router-dom'
import CartItem from 'components/Cart/CartItem/CartItem'
import styles from './CartItems.module.scss'

const CartItems: React.FC<CartItemsProps> = (props: CartItemsProps) => {
  const {
    cartData,
    totalPrice,
    restaurantName,
    restaurantCurrency: currency,
  } = useCartItems(props)

  return (
    <div className={styles['cart-container']}>
      <h2>Your Order</h2>

      <div className={styles['cart-list']}>
        {cartData && cartData.length > 0 ? (
          cartData.map((item) => (
            <CartItem
              key={item.productId}
              productId={item.productId}
              name={item.productName}
              price={item.price}
              quantity={item.quantity}
              currency={currency}
              variantName={item.variantName}
            />
          ))
        ) : (
          <div className={styles['empty-cart']}>
            <i
              className='bi bi-cart-x'
              style={{
                fontSize: '2rem',
                display: 'block',
                marginBottom: '10px',
              }}
            ></i>
            Your cart is empty
          </div>
        )}
      </div>

      {cartData && cartData.length > 0 && (
        <div className={styles['cart-footer']}>
          <div className={styles['total-row']}>
            <span>Total</span>
            <span className={styles['total-price']}>
              {totalPrice.toFixed(2)} {currency}
            </span>
          </div>

          <Link
            to={`/${restaurantName}/Checkout`}
            className={styles['checkout-btn']}
          >
            Checkout <i className='bi bi-arrow-right'></i>
          </Link>
        </div>
      )}
    </div>
  )
}

export default CartItems
